import { render } from "./ButtonsComponent.vue?vue&type=template&id=f86281e0"
import script from "./ButtonsComponent.vue?vue&type=script&lang=js"
export * from "./ButtonsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__